import React, { useEffect, useRef } from 'react';
import Notification from '../Notification';
import './ErrorSummary.scss';

interface ErrorItem {
  key: string;
  message: string;
}

interface ErrorSummaryProps {
  title?: string;
  errors?: ErrorItem[];
  children?: React.ReactNode | React.ReactNode[];
}

const ErrorSummary: React.FC<ErrorSummaryProps> = ({ title = '', errors = [], children }) => {
  const errorSummaryEl = useRef<HTMLDivElement>(null);
  const errorList = useRef<ErrorItem[]>([]);

  useEffect(() => {
    errorList.current = errors;
    errorSummaryEl.current?.focus();
  }, []);

  useEffect(() => {
    if (JSON.stringify(errors) !== JSON.stringify(errorList.current)) {
      errorSummaryEl.current?.focus();
    }
  }, [errors]);

  return (
    <div className="mss-error-summary" tabIndex={-1} role="alert" ref={errorSummaryEl}>
      <Notification title={title} variant="error">
        {children}
        {errors.length ? (
          <ul className="zb-list">
            {errors.map(({ key, message }) => (
              <li key={key}>
                <a href={`#${key}`}>{message}</a>
              </li>
            ))}
          </ul>
        ) : null}
      </Notification>
    </div>
  );
};

export default ErrorSummary;
